import { spaceContractFieldsSchema, spaceContractSchema } from "../space-mesh/space-contract.js";
//#region src/schemas/http/space-contract.ts
const putSpaceContractBodySchema = spaceContractFieldsSchema;
const patchSpaceContractBodySchema = spaceContractFieldsSchema.pick({
	dispatchPolicy: true,
	publicationMode: true,
	allowedActions: true,
	resultArchivePolicy: true,
	entryBrief: true,
	dispatchBrief: true
}).partial().superRefine((value, ctx) => {
	if (Object.keys(value).length > 0) return;
	ctx.addIssue({
		code: "custom",
		message: "at least one contract patch field is required"
	});
});
const getSpaceContractResponseSchema = spaceContractSchema;
const putSpaceContractResponseSchema = spaceContractSchema;
const patchSpaceContractResponseSchema = spaceContractSchema;
//#endregion
export { getSpaceContractResponseSchema, patchSpaceContractBodySchema, patchSpaceContractResponseSchema, putSpaceContractBodySchema, putSpaceContractResponseSchema };

//# sourceMappingURL=space-contract.js.map